var _defs, _g, _g2, _g3, _tspan, _tspan2, _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCombinedStarTest = function SvgCombinedStarTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3342.45 3421.64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "combinedStar-test_svg__clippath"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2453.98 1742.74 714.09-459.86-708-39.43 323.92-629.94-758.22 382.73-217.27-820.43-256.23 660.36-499.81-502.49 130.22 838.64-848.27-47.24 549.57 447.49L251.15 1892l838.82 135.57-307.02 791.26 595.82-383.69 108.67 699.81 388.18-754.91 658.63 536.32-181.31-684.67 699.88 113.11-598.84-602.06z",
    className: "combinedStar-test_svg__cls-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "combinedStar-test_svg__clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2492.87 1578.8 687.42-498.85h-709.1l288.39-646.97-735.77 424.28-262.54-807.07-219.13 673.59-526.97-473.93 176.65 830.1H342.24l573.59 416.25-614.08 354.12 845.06 88.72-262.55 807.11 573.56-416.24 147.41 692.7 345.61-775.33 687.44 498.87-219.11-673.54 705.09 74.03-631.39-567.84z",
    className: "combinedStar-test_svg__cls-1"
  })), /*#__PURE__*/React.createElement("style", null, ".combinedStar-test_svg__cls-1{fill:none}.combinedStar-test_svg__cls-2{clip-path:url(#combinedStar-test_svg__clippath)}.combinedStar-test_svg__cls-4{fill:var(--color-star-main);opacity:var(--opacity-star-main)}.combinedStar-test_svg__cls-5{mix-blend-mode:multiply}.combinedStar-test_svg__cls-7{fill:var(--color-star-bg)}.combinedStar-test_svg__cls-10,.combinedStar-test_svg__cls-9{mix-blend-mode:hard-light}.combinedStar-test_svg__cls-10{opacity:.05}"), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "/img/bg-noise.png",
    id: "combinedStar-test_svg__bg-noise-svg",
    width: 3000,
    height: 3000
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__star",
    className: "combinedStar-test_svg__cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1811.9 175.81 277.21 1046.8 1082.36 60.28-911.03 586.68 277.21 1046.8-840.27-684.22-911.04 586.69 391.73-1009.55-840.26-684.21 1082.36 60.28L1811.9 175.82Z",
    className: "combinedStar-test_svg__cls-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1055.85 333.68 764.06 768.18 967.46-488.34-495.24 963.1 764.07 768.18-1070.15-172.96-495.23 963.11-166.15-1070-1070.14-172.96 967.46-488.34-166.15-1069.99Z",
    className: "combinedStar-test_svg__cls-4"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__Layer_1",
    className: "combinedStar-test_svg__cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "combinedStar-test_svg__cls-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#combinedStar-test_svg__bg-noise-svg",
    className: "combinedStar-test_svg__cls-10",
    transform: "translate(0 110.88)scale(3.31)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__Layer_5",
    className: "combinedStar-test_svg__cls-5"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__star-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1761.27 59.88 334.99 1029.76h1084.03l-877 636.43 334.99 1029.77-877.01-636.44-877.01 636.44 334.99-1029.77-877.01-636.43h1084.04L1761.27 59.88Z",
    className: "combinedStar-test_svg__cls-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1015.17 259.54 805.59 724.51 938.81-541.38-440.92 989.15 805.6 724.51-1078.11-113.19-440.92 989.16-225.38-1059.1-1078.1-113.19 938.81-541.37-225.38-1059.1Z",
    className: "combinedStar-test_svg__cls-7"
  }))), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#fbfbfb",
      fontFamily: "&quot",
      fontSize: 1296,
      fontWeight: 700
    },
    transform: "translate(1309.45 2038.31)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")))), /*#__PURE__*/React.createElement("g", {
    id: "combinedStar-test_svg__Layer_2",
    className: "combinedStar-test_svg__cls-9"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#combinedStar-test_svg__bg-noise-svg",
    className: "combinedStar-test_svg__cls-10",
    style: {
      clipPath: "url(#combinedStar-test_svg__clippath-1)"
    },
    transform: "translate(0 110.88)scale(3.31)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "combinedStar-test_svg__Layer_4",
    style: {
      fontFamily: "&quot",
      fontSize: 1296,
      fontWeight: 700,
      mixBlendMode: "multiply",
      fill: "var(--color-star-main)",
      opacity: "var(--opacity-star-main)"
    },
    transform: "translate(1338.75 2066.61)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S")))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "/img/bg-noise.png",
    width: 4000,
    height: 4000,
    className: "combinedStar-test_svg__cls-2 combinedStar-test_svg__cls-10"
  })));
};
export default SvgCombinedStarTest;